import { Flex, Box } from "@chakra-ui/react";
import { Overline } from "src/atoms/typography";
import { useTranslation } from "react-i18next";
import DeviceCard from "src/modules/device/components/Card";
import ScrollBox from "src/atoms/ScrollBox/index";

export default function DeviceList({
  devices,
  onPair,
  openManualPairingButton,
  mode,
  shouldOpenPurchaseFlow,
  togglePurchaseFlow,
  frame
}) {
  const { t } = useTranslation();
  return (
    <Box height="100%" pb="24px" pr="4px">
      <Overline
        pt={mode === "modal" ? "28px" : frame ? 0 : "22px"}
        pb="8px"
        color="lowEmphasis"
        textAlign="center"
        textTransform="uppercase"
      >
        {t("pairing.requester.nearbyDevices.deviceList.heading")}
      </Overline>

      <ScrollBox
        height={`calc(100% - ${
          mode === "modal" ? "48px" : frame ? "18px" : "40px"
        })`}
        pt="8px"
        width="100%"
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="start"
          width="100%"
          height="100%"
        >
          <Box flex="1 1 auto">
            {devices.map((device) => (
              <Box key={device.jid} flexShrink={0}>
                <DeviceCard
                  elevationLevel={mode === "modal" ? 2 : 1}
                  device={device}
                  onClick={() =>
                    shouldOpenPurchaseFlow
                      ? togglePurchaseFlow()
                      : onPair(device)
                  }
                  buttonLabel={t("buttons.pair")}
                />
              </Box>
            ))}
          </Box>
          <Box flex="0 0 auto">{openManualPairingButton}</Box>
        </Flex>
      </ScrollBox>
    </Box>
  );
}
